import { configureStore } from '@reduxjs/toolkit';
import Alerts from './reducers/alertsSlice';
import Dashboard from './reducers/dashboardSlice';
import MasterData from './reducers/masterDataSlice';
import Staff from './reducers/staffSlice';
import ThemeOptions from './reducers/themeOptionsSlice';
import User from './reducers/userSlice';
import Users from './reducers/usersSlice';
import Configuration from './reducers/configurationSlice';
import Venue from './reducers/venueSlice';
import Notifications from './reducers/notificationsSlice';
import AppOwnerTable from './reducers/appOwnerSlice';
import Tasks from './reducers/taskSlice';
import Billing from './reducers/billingSlice';
import StaffType from './reducers/staffTypeSlice';
import UploadedFiles from './reducers/uploadedFilesSlice';
import ConfigDocuments from './reducers/configDocumentsSlice';

export const store = configureStore({
  reducer: {
    User,
    Alerts,
    ThemeOptions,
    MasterData,
    Dashboard,
    Staff,
    Users,
    Configuration,
    Venue,
    Notifications,
    AppOwnerTable,
    Tasks,
    Billing,
    StaffType,
    UploadedFiles,
    ConfigDocuments,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const { dispatch, getState } = store;
export default store;
